import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const jumpShotExample = defineVideoTemplate({
  slug: "jump-shot-example",
  title: "Jump shot",
  description: "Moment detection",
  poster: BASE_ASSETS.jumpShotPoster,
  video: BASE_ASSETS.jumpShotVideo,
  prompt: "Clip the timestamp when the ball is scored.",
  annotationFormat: "clip",
  enableThinking: true,
});
